import React from "react";
import { createRoot } from "react-dom/client"; // Import createRoot
import { BrowserRouter } from "react-router-dom";
import App from "./app/App";
import "./i18n";
import * as serviceWorker from "./serviceWorker";
import { ToastContainer } from "react-toastify";

// Create root
const container = document.getElementById("root");
const root = createRoot(container);

root.render(
  <BrowserRouter basename="/">
<ToastContainer
  position="top-right"
  autoClose={2000}
  hideProgressBar={false}
  newestOnTop
  closeOnClick
  pauseOnHover
  theme="colored"   // 🔥 change this
/>
    <App />
  </BrowserRouter>
);

serviceWorker.unregister();
